import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export { formatCompactNumber } from '../components/global/platformStatsFooter/utils/formatNumber';
